import {
  LocalStorageConsts,
  ViewportBannerConsts,
} from 'client/util/Constants';
import DateUtil from 'client/util/DateUtil';
import LocalStorageService from 'client/util/LocalStorageService';

// Banner Local Storage Keys
const {
  bannerDismissed,
} = LocalStorageConsts;
const currentBannerEval = (name, startDate = '', endDate = '') => {
  const bannerOverrides = name ? LocalStorageService.getItem(name) : '';
  if (bannerOverrides) {
    const parsedOverrides = JSON.parse(bannerOverrides);
    return DateUtil.isInDateRange(
      parsedOverrides.startDate,
      parsedOverrides.endDate,
    );
  }

  return DateUtil.isInDateRange(startDate, endDate);
};
/**
 * @param {Object} config Object containing banner configuration
 * @property {function} config.bannerVisibility a function that returns a boolean
 * ... list all other properties of config here!
 * @param {String} id Optional id parameter, defaults to orgId
 * @returns {Object} Banner object with visibility logic
 */
export default function Banner(config = {}) {
  const {
    bannerType = ViewportBannerConsts.types.info,
    bannerText = '',
    bannerTextAfter = '',
    emoji = '',
    icon = '',
    learnMoreLink,
    learnMoreText,
    localStorageKey = bannerDismissed,
    startDate = '',
    endDate = '',
    childComponent = null,
  } = config;
  let {
    bannerVisibility = () => false,
    canCloseBanner = true,
    name = '',
  } = config;
  if (typeof bannerVisibility !== 'function') {
    bannerVisibility = () => false;
  }
  if (typeof canCloseBanner !== 'boolean') {
    canCloseBanner = true;
  }
  if (typeof name !== 'string') {
    name = '';
  }
  this.name = name;
  this.bannerType = bannerType;
  this.bannerText = bannerText;
  this.bannerTextAfter = bannerTextAfter;
  this.canCloseBanner = canCloseBanner;
  this.emoji = emoji;
  this.icon = icon;
  this.learnMoreLink = learnMoreLink;
  this.learnMoreText = learnMoreText;
  this.localStorageKey = localStorageKey;
  this.childComponent = childComponent;
  this.startDate = startDate.length > 0 ? new Date(`${startDate} 00:00`) : new Date();
  this.endDate = endDate.length > 0 ? new Date(`${endDate} 00:00`) : new Date();
  this.isCurrentBanner = currentBannerEval(this.name, this.startDate, this.endDate);
  this.showBanner = this.isCurrentBanner && bannerVisibility();
}
